import debounce from 'lodash/debounce';
import { VideoPlayerActionContext } from '../../../types';
import { Question } from './class/Questions';
import { FilmReviewServiceAnsweringMethods, FilmReviewServiceData } from './types';
import { FilmReviewServiceWebcall } from './webcall';

type Ctx = VideoPlayerActionContext;

const accumulateTraversableQuestions = (question: Question | null, acc: Question[] = []): Question[] => {
  if (question == null) {
    return acc;
  }

  return accumulateTraversableQuestions(question.next, [...acc, question]);
};

export const createFilmReviewServiceAnsweringMethods = (context: Ctx | null, webcall: FilmReviewServiceWebcall | null, vm: FilmReviewServiceData | null): FilmReviewServiceAnsweringMethods => {
  if (context == null || webcall == null || vm == null) {
    return {
      upload: (): void => { /* void */ },
    };
  }

  const debounced = debounce(webcall.answerQuestions, 500);

  return {
    upload(): void {
      const questions = accumulateTraversableQuestions(vm.questions?.root || null);
      const answers = questions.map(question => ({
        id: question.id,
        values: question.answers || [],
      }));

      debounced(answers);
    },
  };
};
